import "core-js/stable";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/router";
import "./plugins/argon-design-system";
import "./plugins/flat-picker";
import "./plugins/aws-auth";
import "./plugins/vue-phone-number-input";
import App from "./App.vue";
import VueRouter from "vue-router";

import store from "./components/store";
import routes from "./routes";
/* assets */
import "./assets/override.scss";
import "./assets/logo.scss";

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
